import {createGAEvent, HTO, pushDataLayer} from '@optimaxdev/analytics/mobile';

/**
 * Send segment hto analytic event.
 * @param {string} currentHtoSegment - current HTO segment value.
 */
export const sendSegmentHtoEvent = (currentHtoSegment: string) => {
    const eligibleEvent = createGAEvent(
        HTO.SEGMENT_CHANGED,
        {
            currentHtoSegment,
        },
        false,
    );
    pushDataLayer(eligibleEvent);
};
